import * as React from 'react'

function SvgCross(props, svgRef) {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        clipRule="evenodd"
        d="M17.623.377a1.286 1.286 0 010 1.818L2.195 17.623a1.286 1.286 0 11-1.818-1.818L15.805.377a1.286 1.286 0 011.818 0z"
      />
      <path
        clipRule="evenodd"
        d="M.377.377a1.286 1.286 0 011.818 0l15.428 15.428a1.286 1.286 0 01-1.818 1.818L.377 2.195a1.286 1.286 0 010-1.818z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgCross)
export default ForwardRef
